import i18n from '@yandex-int/i18n';

export function formatBytes(bytes: number, decimals = 2) {
    if (bytes === 0) {
        return '0 B';
    }

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

export const objectsDiff = (source: Record<string, unknown> | undefined, target: Record<string, unknown>) => {
    const clone = { ...target };
    const result: string[] = [];
    Object.keys(source || {}).forEach((key) => {
        if (source?.[key] !== target[key]) {
            result.push(key);
        }
        delete clone[key];
    });
    result.push(...Object.keys(clone));
    return result;
};

export const i18nWrapper = <T extends { en: Record<keyof T[keyof T], string>; ru: Record<keyof T[keyof T], string> }>(
    k: T,
): ((key: keyof T[keyof T] | '') => string) => {
    const innerT = i18n(k);
    return (key: keyof T[keyof T] | '', vars?: unknown) => (key ? innerT(key, vars) : '');
};
